// client/src/utils/recentlyViewed.js
const KEY = 'recentlyViewedProducts';
const MAX_ITEMS = 12;

export const getRecentlyViewed = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

// Stores just enough of the product to render a card without refetching.
export const addRecentlyViewed = (product) => {
  try {
    const existing = getRecentlyViewed().filter((p) => p.id !== product.id);
    const entry = {
      id: product.id, name: product.name, price: product.price,
      compare_at_price: product.compare_at_price, imageUrl: product.imageUrl,
      category: product.category, quantity: product.quantity,
    };
    const next = [entry, ...existing].slice(0, MAX_ITEMS);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // localStorage can throw in private browsing / when full — not worth surfacing.
  }
};
